import * as queryString from 'query-string';
import * as React from 'react';
import { Route, Switch } from 'react-router';

import { ServiceLocator } from '../app/ServiceLocator';
import { getSessionManagementServiceInstance, SessionManagementService } from '../sessionManagement/SessionManagementService';
import { GenerateCodeChallenge } from './GenerateCodeChallenge';
import { GetAuthorizationCode } from './GetAuthorizationCode';
import { PKCELogin } from './PKCELogin';
import { PKCEUrls } from './PKCEUrls';

export const PKCERouter: React.FunctionComponent = () => {
  const sessionManagementService = getSessionManagementServiceInstance();
  return (
    <Switch>
      <Route exact path={PKCEUrls.generateCodeChallengePath()} render={routeProps => {
        const queryParams = queryString.parse(routeProps.location.search);
        return <GenerateCodeChallenge appUriProtocol={queryParams.appUriProtocol}/>;
      }}/>
      <Route exact path={PKCEUrls.getAuthorizationCodePath()} render={routeProps => {
        const queryParams = queryString.parse(routeProps.location.search);
        return <GetAuthorizationCode
          appUriProtocol={queryParams.appUriProtocol}
          codeChallenge={queryParams.codeChallenge}
          codeChallengeMethod={queryParams.codeChallengeMethod}
          requireSignIn={queryParams.requireSignIn}
          currentSessionIsValid={sessionManagementService.inSession()}
          location={routeProps.location}
          targetSite={queryParams.targetSite}
        />;
      }}/>
      <Route exact path={PKCEUrls.loginPath()} render={routeProps => {
        const queryParams = queryString.parse(routeProps.location.search);
        return <PKCELogin authorizationCode={queryParams.authorizationCode} host={queryParams.host}/>;
      }}/>
    </Switch>
  );
};
